import {flatMap, get, has, isNil} from 'lodash'

/**
 * Reusable patterns
 */


export const fieldToNumber = (field) => {
  return get(field, 'id', null)
}

export const fieldsToNumberList = (fields = []) => {
  return flatMap(fields, f => fieldToNumber(f))
}


// Translates a contact from the server to the client
export const contactInbound = (contact) => {
  return {
    ...contact,
    // Create ID lists
    contactMethodIds: contact.contactmethods ? contact.contactmethods.filter(v => v.subscribed).map(v => v.contactMethodId) : null,
    userFieldValues: contact.userfields ? mapUserFieldValues(contact.userfields) : null,
    company: isNil(contact.company)
        ? null
        : companyInbound(contact.company),
  }
}

// Translates a contact from the client to the server
export const contactOutbound = (contact) => {
  const {address, ...props} = contact

  delete props.company
  delete props.contactmethods
  delete props.accountmanager
  delete props.campaign
  delete props.historystat

  const splitAddress = address ? address.split(/\n/g) : {}
  const address1 = splitAddress[0]
  const address2 = splitAddress[1]
  const address3 = splitAddress[2]

  return {
    ...props,
    address1,
    address2,
    address3,
    company: isNil(contact.company)
        ? null
        : companyOutbound(contact.company),
  }
}

// Translates a company from the server to the client
export const companyInbound = (company) => {
  return {
    ...company,

    // Create ID lists
    groupIds: company.groups ? company.groups.map(v => v.id) : null,
    productIds: company.products ? company.products.map(v => v.id) : null,
    userFieldValues: company.userfields ? mapUserFieldValues(company.userfields) : null,
  }
}

// Translates a company from the client to the server
export const companyOutbound = (company) => {
  // Remove anything that is not editable
  // const { groups, products, contacts, locations, salesinfo, historystat, accountingcompany, referralcompany, userfields, address, ...props } = company
  const {address, ...props} = company
  const splitAddress = address ? address.split(/\n/g) : []
  const address1 = splitAddress.length > 0 ? splitAddress[0] : null
  const address2 = splitAddress.length > 1 ? splitAddress[1] : null
  const address3 = splitAddress.length > 2 ? splitAddress[2] : null
  return {address1, address2, address3, ...props}
}

const mapUserFieldValues = (userFields) => {
  const ret = {}
  Object.keys(userFields).forEach(field => {
    ret[field] = userFields[field].value
  })
  return ret
}

export default {
  contactInbound,
  companyInbound,
  contactOutbound,
  companyOutbound,
}

// Deprecated: Please use api.handleResponse

export const getFailureReason = (response) => {
  if (has(response, 'data.message')) return response.data.message
  return getFailureDescForHttpCode(response.status) || 'Sorry, a problem occurred'
}

export const getFailureDescForHttpCode = (httpCode) => {
  switch (httpCode) {
    case 404:
    case 502:
    case 504:
      return 'We are currently upgrading Clarity Go to improve your experience, and should be back with you very soon. Please try again in a minute.'
    default:
      return null
  }
}

export const getFailureCode = (response) => {
  return response.data && response.data.errorCode
      ? response.data.errorCode
      : response.status
}

export const getFailureData = (response) => {
  if (response.data && response.data.data) return response.data.data
  return {}
}

export const getFailureDataValue = (response, name) => {
  if (response.data && response.data.data && response.data.data[name]) return response.data.data[name]
  return null
}

export const getFailureMessage = (response) => {
  return response.data && response.data.message
      ? response.data.message
      : response.problem
}